export default "__VITE_ASSET__60802861__"